import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BreakoutAlerts from '../../pages/breakout-alerts';

const BreakoutAlertsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <BreakoutAlerts widget={true} widgetRows={4} {...props}/>
    </QueryClientProvider>
  );
};

export { BreakoutAlertsFullWidget };
